// This icon file is generated automatically.
var PRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.96 5.6L2.92.1a.12.12 0 00-.2.1v1.21c0 .08.03.15.1.2L8.43 6 2.8 10.4a.25.25 0 00-.1.19v1.2c0 .11.13.17.21.1l7.04-5.5a.5.5 0 000-.78z", "fill-rule": "nonzero" } }] }, "name": "p-right", "theme": "outlined" };
export default PRightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PRightOutlined.js
// module id = 3601
// module chunks = 0